import React, { useContext, useMemo } from 'react';

import {
  companyRegistrationRequest,
  createPayScheduleRequest,
  uploadPayScheduleContractWrapperRequest,
} from '@vyce/core/src/api/pay';
import {
  getStaffRequest,
  listAvailableRolesRequest,
  updateStaffPermissionsRequest,
} from '@vyce/core/src/api/companies';
import { PayrollOnboarding } from '@vyce/core/src/views/payroll/PayrollOnboarding';
import { PayModuleContext, PayModuleProvider } from '@vyce/core/src/contexts';

import { useActions, useTypedSelector } from '../../hooks';

export const EmployerPayrollOnboarding: React.FC = () => {
  const { setPosition, updateSelectedCompanySubscription, fetchPaySchedules } = useActions();
  const { access_token, selectedPosition, selectedCompany, selectedCompanyAppData } = useTypedSelector(
    state => state.helper
  );
  const { user } = useTypedSelector(state => state);
  const payModuleContext = useContext(PayModuleContext);
  const subscribed = useMemo(
    () => selectedCompanyAppData?.subscription?.active ?? false,
    [selectedCompanyAppData?.subscription?.active]
  );

  return (
    <PayModuleProvider value={{ ...payModuleContext, fetchPaySchedules }}>
      <PayrollOnboarding
        uploadPayScheduleContractWrapperRequest={uploadPayScheduleContractWrapperRequest}
        setPosition={setPosition}
        token={access_token}
        selectedPosition={selectedPosition}
        createPayScheduleRequest={createPayScheduleRequest}
        companyRegistrationRequest={companyRegistrationRequest}
        user={user}
        subscribed={subscribed}
        wasSubscribed={selectedCompany?.subscribed_company}
        updateSelectedCompanySubscription={updateSelectedCompanySubscription}
        getStaffRequest={getStaffRequest}
        getRolesRequest={listAvailableRolesRequest}
        updateStaffPermissionsRequest={updateStaffPermissionsRequest}
      />
    </PayModuleProvider>
  );
};
